export const MODEL_EVENT = 'input'
export const FACET_NAME_PREFIX = 'facets_'
